module.exports = __webpack_public_path__ + "img/DE01833.5c558e02.png";